import { gql } from '@apollo/client';

export const ADD_USER = gql`
  mutation AddUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
    }
  }
`;
